import { render, staticRenderFns } from "./CellRendererLargeTextModal.vue?vue&type=template&id=524b5d07&scoped=true&"
import script from "./CellRendererLargeTextModal.vue?vue&type=script&lang=js&"
export * from "./CellRendererLargeTextModal.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererLargeTextModal.vue?vue&type=style&index=0&id=524b5d07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b5d07",
  null
  
)

export default component.exports